<template>
  <div class="mb-4">

    <div class="row">
      <div class="col">
        <div class="alert alert-info" role="alert">
          <h4>You tried to purchase&hellip;</h4>
          <table class="table table-striped table-light text-left">
            <thead class="thead-dark">
              <tr>
                <th>Item</th>
                <th>Details</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="saleItem in sale.sale_items">
                <template v-if="saleItem.saleable_type == 'App\\Models\\Booking'">
                  <td style="vertical-align: middle;">
                    <div class="row">
                      <div class="col">
                        <img :alt="saleItem.saleable.room_slot.room.name" :src="'/img/mp/mp-ls-' + saleItem.saleable.room_slot.room.nickname + '.jpg'" width="100" class="mr-2">
                        <span class="heading" :class="'text-' + saleItem.saleable.room_slot.room.nickname"> {{ saleItem.saleable.room_slot.room.name }}</span>
                      </div>
                    </div>
                  </td>
                </template>
                <template v-if="saleItem.saleable_type == 'App\\Models\\Voucher'">
                  <td style="vertical-align: middle;">
                    <div class="row">
                      <div class="col">
                        <img src="/img/mp/mp-ls-voucher.jpg" alt="Gift Voucher" width="100" class="mr-2">
                        <span class="heading text-cs-green">Gift Voucher</span>
                      </div>
                    </div>
                  </td>
                </template>
                <template v-if="saleItem.saleable_type == 'App\\Models\\VirtualGame'">
                  <td style="vertical-align: middle;">
                    <div class="row">
                      <div class="col">
                        <img :alt="saleItem.saleable.name" :src="'/img/mp/mp-ls-' + saleItem.saleable.nickname + '.jpg'" width="100" class="mr-2">
                        <span class="heading" :class="'text-' + saleItem.saleable.nickname"> {{ saleItem.saleable.name }}</span>
                      </div>
                    </div>
                  </td>
                </template>

                <td style="vertical-align: middle;">
                  {{ saleItem.description }}
                </td>
                <td style="vertical-align: middle;">
                  {{ saleItem.sold_for | money }}
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-sm-6">
            <div class="alert alert-success text-left" role="alert">
              <p class="h4">Total Cost: <strong>{{ sale.total_amount | money }}</strong></p>
              <p v-if="sale.transactions_sum_amount && sale.left_to_pay" class="h4">Left To Pay: <strong>{{ sale.left_to_pay | money }}</strong></p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="alert alert-primary text-center" role="alert" style="padding-top: 6px; padding-bottom: 6px;">
              <button class="btn btn-lg btn-primary" @click="takePayment">Try Payment Again</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pay-handler
      ref="payComponent"
      :location="location"/>
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    sale: {
      type: Object,
      required: true,
    },
  },

  methods: {
    takePayment() {
      this.$refs.payComponent.takeSalePayment(this.sale, false);
    },
  },
}
</script>
